// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XzcF","rootMobile":"styles_rootMobile__HAyl3"};